export enum NetworkNet {
  Mainnet = 'mainnet',
  Testnet = 'testnet',
}
